import React, { Component } from 'react';
import { Button, Tooltip, Icon } from 'antd';
import ListPage from '../../../../../components/ListPage';

const { ListTable } = ListPage;

class Common extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {}

  render() {
    const { tableProps, downUrl } = this.props;
    const { list, all } = downUrl;

    return (
      <section className="table-area">
        <div style={{ textAlign: 'right' }}>
          <Tooltip placement="top" title="当前页面列表中存在的统计数据内容">
            <Button type="primary" style={{ marginRight: 8 }} href={list}>
              导出列表明细
              <Icon type="question-circle" />
            </Button>
          </Tooltip>
          <Tooltip placement="top" title="本月度当前组织以及所有下属局、校的统计数据内容">
            <Button href={all}>
              导出全部明细
              <Icon type="question-circle" />
            </Button>
          </Tooltip>
        </div>

        <ListTable {...tableProps} />
      </section>
    );
  }
}

export default Common;
